import type { Prompt } from "@akhshy/types";
import { PromptCard } from "../molecules/PromptCard.tsx";
import { Spinner } from "../atoms/Spinner.tsx";
import { LoadMore } from "../atoms/LoadMore.tsx";
import { usePaginated } from "../../lib/usePaginated.ts";
import { client } from "../../lib/api.ts";
import { FALLBACK_PROMPTS } from "../../lib/fallback.ts";

export function PromptList() {
  const { items, loading, hasMore, total, loadMore } = usePaginated<Prompt>(
    (page) => client.prompts.list({ page, pageSize: 6 }),
    [],
    FALLBACK_PROMPTS.slice(0, 6),
  );

  if (loading && items.length === 0) {
    return <Spinner label="digging out the good ones" />;
  }
  return (
    <>
      <div className="prompt-list">
        {items.map((p) => (
          <PromptCard key={p.id} prompt={p} />
        ))}
      </div>
      <LoadMore
        hasMore={hasMore}
        loading={loading}
        total={total}
        count={items.length}
        onClick={loadMore}
      />
    </>
  );
}
